import React from 'react';
import TripSummary from '../TripSummary';
import { ScrollView, StyleSheet, SafeAreaView } from 'react-native';
import { CommonProperties } from '../../styles';

const TripSummaryModal = () => {
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.scroll}>
        <TripSummary />
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.py5,
  },
  scroll: {
    flex: 1,
    ...CommonProperties.px3,
  },
});

export default TripSummaryModal;
